<template>
  <div>
    <el-row :gutter="15">

      <el-col>

        <el-card>
          <el-row>
            <el-col>
              <el-date-picker style="float: left;width:300px;margin-bottom: 10px;" value-format="yyyy-MM-dd"
                v-model="dateTime" type="daterange" size="small" class="query" range-separator="至"
                start-placeholder="消耗开始日期起始" end-placeholder="消耗开始日期结束" clear-icon @clear="() => { this.dateTime = []; }"
                @change="() => {
                  queryinit()
                }">
              </el-date-picker>
            </el-col>
          </el-row>

          <el-row :gutter="15">
            <el-col :span="14">
              <el-table :data="MatUseDate" ref="assetTable" show-overflow-tooltip border stripe size="mini"
                height="calc(100vh - 180px)" v-loading="loading">

                <el-table-column type="index" label="序号" width="50" align="center">
                </el-table-column>
                <el-table-column prop="name" label="工区名称"> </el-table-column>
                <el-table-column prop="value" label="消耗材料金额"> </el-table-column>
                <el-table-column prop="per" label="百分比">
                </el-table-column>
              </el-table>
            </el-col>

            <el-col :span="10">

              <div id="elePieMatuse" style="width: 100%;   height:460px;">

              </div>

            </el-col>
          </el-row>

        </el-card>
      </el-col>
    </el-row>

</div>
</template>

<script>
import dateutils from '../../utils/dateutils.js'
export default {
  name: 'matstatistic',
  data () {
    return {
      queryObj: { starttime: [], endtime: [] },//查询条件       
      dateTime: [],
      loading: false,
      MatUsePie: [],
      MatUseDate: []
    }
  },
  methods: {
    //页面初始化
    init () {
      let millisecond = 1000 * 60 * 60 * 24;
      this.dateTime = [dateutils.dateFormat("YYYY-mm-dd 00:00:00", new Date((new Date()).getTime() - 7 * millisecond)), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.loadMatUseDate()
    },

    queryinit () {
      this.loadMatUseDate()
    },

    loadMatUseDate () {
      this.loading = true
      this.queryObj.starttime = this.dateTime[0]
      this.queryObj.endtime = this.dateTime[1]
      this.$ajax.get('/buss/statisticmat/loadmatusedate', this.queryObj).then(msg => {
        this.MatUseDate = msg.tablelist

        this.MatUsePie = msg.pielist


        this.initMatUsePie()
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })

    },



    initMatUsePie () {
      let myChart = this.$echarts.init(document.getElementById('elePieMatuse'))
      var colorList = ['#f1bb4c', '#BEE5FB', '#1EE7E7', '#00D68A', '#1890FF', '#564AF1', '#afa3f5', '#40d488', '#3feed4', '#3bafff', '#f1bb4c', '#aff', '#afa3f5', '#00d488', '#3feed4', '#3bafff', '#f1bb4c', '#aff', '#afa3f5', '#00d488', '#3feed4', '#3bafff', '#f1bb4c', '#aff',];
      var option = {
        title: {
          subtext: '工区占分公司材料消耗率',
          x: 'center',
          y: '2%',
          textStyle: {
            fontSize: 18,
            fontWeight: 'normal',
            color: ['#333']
          },
          subtextStyle: {
            color: '#f1bb4c',
            fontSize: 16
          },
        },
        grid: {
          bottom: 150,
          left: 0,
          right: '10%'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          show: false,
          orient: 'vertical',
          top: "middle",
          right: "5%",
          textStyle: {
            color: '#f2f2f2',
            fontSize: 25,
          },
          icon: 'roundRect'
        },
        series: [
          // 主要展示层的
          {
            radius: ['19%', '63%'],
            center: ['50%', '60%'],
            name: '工区名称',
            type: 'pie',
            itemStyle: {
              normal: {
                color: function (params) {
                  return colorList[params.dataIndex]
                }
              }
            },
            labelLine: {
              normal: {
                show: false,
                length: 5,
                length2: 60,
                lineStyle: {
                  color: '#d3d3d3'
                },
                align: 'right'
              },
              color: "#000",
              emphasis: {
                show: false
              }
            },
            label: {
              normal: {
                formatter: function (params) {
                  var str = params.name + params.value;
                  return str
                },
                padding: [0, -90],
                height: 35,
              }
            },
            data: this.MatUsePie,
          },
          // 边框的设置
          {
            radius: ['58%', '65%'],
            center: ['50%', '60%'],
            type: 'pie',
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            animation: false,
            tooltip: {
              show: false
            },
            itemStyle: {
              normal: {
                color: 'rgba(250,250,250,0.5)'
              }
            },
            data: [{
              value: 1,
            }],
          }
        ]
      };
      myChart.setOption(option)
    }
  },

  mounted () {
    this.init()
  }
}
</script>
<style scoped></style>
